module.exports = __webpack_public_path__ + "64d7c6facd5d15223e87371bd39b7bea.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/pottery_barn.png
// module id = 642
// module chunks = 0